import styled from 'styled-components';
import COLORS from '../../style/universal.color';
import { MLBTheme } from '../../style/theme.types';
import BREAKPOINTS from '../../style/breakpoints';
import { AnimateFrom } from './animatedModal.types';
import * as animations from '../../style/animations';

interface PropTypes {
  theme: MLBTheme;
  customWidth?: string;
  customHeight?: string;
  fullScreenMobile?: boolean;
  position?: Position;
  animate?: boolean;
  animateFrom?: AnimateFrom;
  animationDuration: number;
  animateOut?: boolean;
  dragAnimation?: string;
  ref?: React.Ref<HTMLDivElement>;
}
interface Position {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}
const inAnimation = {
  top: animations.slideInDown,
  bottom: animations.slideInUp,
  right: animations.slideInRight,
  left: animations.slideInLeft,
};
const outAnimation = {
  top: animations.slideOutUp,
  bottom: animations.slideOutDown,
  right: animations.slideOutRight,
  left: animations.slideOutLeft,
};

// Returns a wrapper for the Modal
export const Wrapper = styled.div.attrs({
  'aria-modal': true,
})<PropTypes>`
  display: flex;
  flex-direction: column;
  position: fixed;
  box-sizing: border-box;
  ${(props) => {
    if (props.position !== undefined && !props.fullScreenMobile) {
      return Object.keys(props.position).reduce(
        (acumulator: string, key: string) =>
          props.position ? `${acumulator} ${key}: ${props.position[key as keyof Position]}px;` : '',
        '',
      );
    }
    return 'top: 0; left: 0;';
  }}
  animation:${(props) => (props.animate ? (props.animateOut ? outAnimation.bottom : inAnimation.bottom) : '')};
  animation-duration: ${(props) => props.animationDuration}s;
  z-index: 99994;
  border-radius: 5px;
  border: 1px solid ${(props) => (props.theme.dark ? COLORS.mlbGrey6 : COLORS.mlbGrey2)};
  background-color: ${(props) => (props.theme.dark ? COLORS.mlbGrey7 : COLORS.mlbWhite)};
  ${(props) =>
    props.fullScreenMobile
      ? 'width: 100%; height:100%;'
      : `
    width: ${props.customWidth ? `${props.customWidth}` : 'fit-content'};
    height: ${props.customHeight ? `${props.customHeight}` : 'fit-content'};
  `}
  overflow: hidden;
  @media only screen and (min-width: ${BREAKPOINTS.md}) {
    ${(props) => `
      width: ${props.customWidth ? `${props.customWidth}` : 'fit-content'};
      height: ${props.customHeight ? `${props.customHeight}` : 'fit-content'};
  `}
    ${(props) => {
      if (props.position !== undefined) {
        return Object.keys(props.position).reduce(
          (acumulator: string, key: string) =>
            props.position ? `${acumulator} ${key}: ${props.position[key as keyof Position]}px;` : '',
          '',
        );
      }
      return 'top: 0; left: 0;';
    }}
  animation:${(props) =>
      props.animateFrom ? (props.animateOut ? outAnimation[props.animateFrom] : inAnimation[props.animateFrom]) : ''};
    animation-duration: ${(props) => props.animationDuration}s;
  }
  ${(props) => props.dragAnimation}
`;

export const ContentWrapper = styled.div`
  width: 100%;
  flex-grow: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  overscroll-behavior: contain;
`;
